import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs/index';
import {QuoteConstants} from '../../../quotes/model/quote';
import {TitleService} from '../../../shared/services/title.service';
import {Product, ProductContainer} from '../../models/product';
import * as fromProducts from '../../reducers';
import * as fromQuote from '../../../quotes/reducers';
import * as quoteAction from '../../../quotes/actions/quote.action'
import * as fromRoot from '../../../reducers';
import * as LayoutActions from '../../../core/actions/layout.actions';
import * as ProductAction from '../../actions/product.actions';
import {GalleryItem, ImageItem} from 'ng-gallery';
import {environment} from 'src/environments/environment';
import * as DetailActions from '../../actions/detail.actions'
import { StoreService } from 'src/app/core/services/store.service';
import { PriceHintService } from 'src/app/core/services/price-hint.service';


@Component({
    selector: 'app-product-page',
    templateUrl: './product-page.component.html',
    styleUrls: ['./product-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPageComponent implements OnInit, OnDestroy {
    images: GalleryItem[];
    qtySelectionOptions: string[] = ["1", "2", "3", "4", "5", "6", "7", "8+"];
    productContainer: ProductContainer;
    readonly decorDefaultName = QuoteConstants.DECOR_DEFAULT_NAME;
    private onRouteChanges$: Subscription;
    private onProductContainerChange$: Subscription;
    addToQuote$: Observable<boolean>;
    getIsDetailTextOpen$: Observable<boolean>;
    getIsSafetyTextOpen$: Observable<boolean>;
    activateFreeText$: Observable<boolean>;
    selectedOption$: Observable<number>;

    constructor(private store: Store<fromProducts.State>,
                private route: ActivatedRoute,
                private titleService: TitleService,
                private changeDetectorRef: ChangeDetectorRef,
                private rootState: Store<fromRoot.State>,
                public storeService: StoreService,
                public priceHintService: PriceHintService
                ) {
    }

    get isLoading(): boolean {
        if (this.productContainer) {
            return this.productContainer.isLoading;
        } else {
            return true;
        }
    }

    get product(): Product {
        if (this.productContainer) {
            return this.productContainer.product;
        } else {
            return null;
        }
    }

    ngOnInit() {
        this.onRouteChanges$ = this.route.params.subscribe(params => {
            this.onProductIdChanges(params.id);
        });
        this.addToQuote$ = this.store.pipe(select(fromQuote.getAddToQuoteNav));
        this.store.dispatch(ProductAction.select({id: this.product.id}))

        this.images = this.product.mediaGalleryEntries.map(entry => {
            const src =  this.getProductsMediaResourceURL(entry);
            return new ImageItem({src, thumb: src});
        });
        this.getIsDetailTextOpen$ = this.store.pipe(select(fromProducts.getIsDetailTextOpen));
        this.getIsSafetyTextOpen$ = this.store.pipe(select(fromProducts.getIsSafetyMenuOpen));
        this.activateFreeText$ = this.store.pipe(select(fromProducts.getIsFreeTextActive));
        this.selectedOption$ = this.store.pipe(select(fromProducts.getSelectedQuantity));
    }

    ngOnDestroy(): void {
        this.onRouteChanges$.unsubscribe();
        this.unsubscribeProductContainerChange();
    }

    openDetailText() {
        this.store.dispatch(DetailActions.openDetailText());
    }
    closeDetailText() {
        this.store.dispatch(DetailActions.closeDetailText());
    }
    openSafetyText() {
        this.store.dispatch(DetailActions.openSafetyText());
    }
    closeSafetyText() {
        this.store.dispatch(DetailActions.closeSafetyText());
    }

    openAddToQuoteDialog() {
        this.store.dispatch(quoteAction.openAddToQuoteNav())
        this.store.dispatch(quoteAction.openAddToQuoteMenu())
        this.rootState.dispatch(LayoutActions.openQuoteList());
    }

    changeQuantityOption(selectedValue) {
        if (!Number(selectedValue)) {
            this.store.dispatch(DetailActions.activateFreeText());
            this.store.dispatch(DetailActions.selectedQuantity({selectedQuantity: 8}));
        } else {
            selectedValue = Number(selectedValue);
            this.store.dispatch(DetailActions.selectedQuantity({selectedQuantity: selectedValue}));
        }
    }

    private unsubscribeProductContainerChange() {
        if (this.onProductContainerChange$ != null) {
            this.onProductContainerChange$.unsubscribe();
        }
    }

    private onProductIdChanges(productId: number) {
        this.unsubscribeProductContainerChange();

        const productContainer$ = this.store.pipe(select(fromProducts.getProductContainerById(productId)));
        this.onProductContainerChange$ = productContainer$.subscribe(productContainer => {
            if (productContainer == null || productContainer.product == null) {
                return;
            }
            this.titleService.setTitle(productContainer.product.name);
            this.productContainer = productContainer;
            this.store.dispatch(ProductAction.selectProduct(productContainer.product));

            this.changeDetectorRef.detectChanges();
        });
    }

    private getProductsMediaResourceURL(mediaPath: string) {
        const mediaBasePath = '/media/catalog/product';
        return environment.backend + mediaBasePath + mediaPath;
    }

}
